<template>
    <nav
        class="o-mainNav main-nav navbar navbar-expand-lg navbar-light bg-white"
    >
        <transition name="slide">
            <div
                class="collapse navbar-collapse show"
                v-if="showMenu"
                id="main-nav"
            >
                <div class="container d-block">
                    <ul class="navbar-nav main-nav-list">
                        <template v-for="(link, idx) in links">
                            <router-link
                                v-if="!link.isHidden"
                                :key="idx"
                                class="nav-item"
                                :to="link.link"
                                :disabled="link"
                                tag="li"
                                :class="[
                                    {
                                        active: subIsActive(link.link, link.activeLink),
                                        disabled: !link.link
                                    }
                                ]"
                                @click.native="
                                    closeMenu(link.linkClass)
                                    $store.dispatch('setScrollY', null)
                                "
                            >
                                <tooltip-info
                                    v-if="link.linkClass"
                                    class="nav-link"
                                    side="bottom"
                                    :content="true"
                                    text="
                                        Funkcjonalność będzie dostępna w kolejnych wersjach aplikacji.
                                    "
                                >
                                    <a-icon :icon="link.icon" />
                                    <span>{{ link.label }}</span>
                                </tooltip-info>
                                <a v-else class="nav-link">
                                    <a-icon
                                        :icon="link.icon"
                                        class="text-dark"
                                    />
                                    <span>{{ link.label }}</span>
                                </a>
                            </router-link>
                        </template>
                    </ul>
                    <div class="d-lg-none my-3">
                        <the-btn
                            class="btn-secondary ml-2"
                            icon="Help"
                            text="Pomoc"
                            @click="goHelp"
                        />
                    </div>
                </div>
            </div>
        </transition>
    </nav>
</template>

<script>
export default {
    data() {
        return {
            links: [
                {
                    label: 'Pulpit',
                    icon: 'Pulpit',
                    link: '/dashboard'
                },
                {
                    label: 'Promocje',
                    icon: 'Promotions',
                    link: '/promo-list'
                },
                {
                    label: 'Mój Biznes',
                    icon: 'Producenci',
                    link: '/my-business'
                },
                {
                    label: 'Rozliczenia',
                    icon: 'Rozliczenia',
                    link: '/settlements',
                    isHidden: this.$store.getters.isShopUser
                },
                {
                    label: 'Raporty',
                    icon: 'Report',
                    link: '/reports',
                    activeLink: '/statistics'
                },
                {
                    label: 'Cenówki',
                    icon: 'PriceTags',
                    link: '/labels'
                },
                {
                    label: 'Usługi',
                    icon: 'Uslugi',
                    link: '/services',
                    isHidden: this.$store.getters.isShopUser
                },
                {
                    label: 'Pomoc',
                    icon: 'Help',
                    link: '/help'
                }
            ],
            windowWidth: window.innerWidth
        }
    },
    methods: {
        subIsActive(input, activeLink) {
            const paths = Array.isArray(input) ? input : [input]
            if (activeLink && !paths.includes(activeLink)) {
                paths.push(activeLink)
            }
            return paths.some(path => {
                return this.$route.path.indexOf(path) === 0
            })
        },
        closeMenu(linkClass) {
            if (
                this.showMenu &&
                this.windowWidth < 992 &&
                linkClass !== 'disabled'
            ) {
                this.$store.dispatch('toggleMobileMenu', false)
            }
        },
        goHelp() {
            this.$store.dispatch('toggleMobileMenu', false)
            this.$router.push({ name: 'help' })
        }
    },
    computed: {
        showMenu() {
            return this.$store.getters.getShowMobileMenu
        }
    },
    mounted() {
        window.onresize = () => {
            this.windowWidth = window.innerWidth
        }
    },
    created() {
        if (this.windowWidth >= 992) {
            this.$store.dispatch('toggleMobileMenu', true)
        }
    },
    watch: {
        windowWidth() {
            if (!this.showMenu && this.windowWidth >= 992) {
                this.$store.dispatch('toggleMobileMenu', true)
            }
            if (this.showMenu && this.windowWidth < 992) {
                this.$store.dispatch('toggleMobileMenu', false)
            }
        }
    }
}
</script>

<style lang="scss">
.nav-item {
    &.disabled {
        &:hover {
            text-decoration: none !important;
        }
        .nav-link {
            .btn {
                cursor: default;
                &:focus {
                    box-shadow: none;
                }
            }
        }
    }
    &.hidden {
        display: none;
    }
}
</style>
